// roles defined in database
export const ROLES = {
  SUPER_USER: "SUPER_USER",

  SYSTEM_DEVELOPER: "SYSTEM_DEVELOPER",

  USER_EDIT_SELF: "USER_EDIT_SELF",
  USER_VIEW: "USER_VIEW",
  USER_ADD: "USER_ADD",

  ACCOUNT_ADMIN: "ACCOUNT_ADMIN",

  EVENT_VIEW: "EVENT_VIEW",
  EVENT_EDIT: "EVENT_EDIT",
  EVENT_ADD: "EVENT_ADD",
  EVENT_DELETE: "EVENT_DELETE",

  BADGE_DESIGNER_VIEW: "BADGE_DESIGNER_VIEW",
  BADGE_DESIGNER_EDIT: "BADGE_DESIGNER_EDIT",
  BADGE_DESIGNER_ADD: "BADGE_DESIGNER_ADD",

  BADGE_SIZE_VIEW: "BADGE_SIZE_VIEW",
  BADGE_SIZE_EDIT: "BADGE_SIZE_EDIT",
  BADGE_SIZE_ADD: "BADGE_SIZE_ADD",
};

// permissions defined for UI
export const PERMISSIONS = {
  CAN_VIEW_API: "CAN_VIEW_API",
  CAN_VIEW_INTERNAL_API: "CAN_VIEW_INTERNAL_API",
  CAN_MANAGE_EVENT: "CAN_MANAGE_EVENT",
  CAN_MANAGE_BADGE_DESIGN: "CAN_MANAGE_BADGE_DESIGN",
  CAN_MANAGE_BADGE_SIZE: "CAN_MANAGE_BADGE_SIZE",
  CAN_MANAGE_ACCOUNT: "CAN_MANAGE_ACCOUNT",
  CAN_MANAGE_DEV_ACCOUNT: "CAN_MANAGE_DEV_ACCOUNT",
  CAN_MANAGE_USER: "CAN_MANAGE_USER",
  CAN_MANAGE_ATTENDEE: "CAN_MANAGE_ATTENDEE",
  CAN_MANAGE_SESSION: "CAN_MANAGE_SESSION",
  CAN_MANAGE_RESERVATION: "CAN_MANAGE_RESERVATION",
  CAN_DELETE_EVENT: "CAN_DELETE_EVENT",
  CAN_VIEW_ANALYTICS: "CAN_VIEW_ANALYTICS",
  CAN_MANAGE_LEADS: "CAN_MANAGE_LEADS",
  CAN_MANAGE_KIOSK: "CAN_MANAGE_KIOSK",
  CAN_MANAGE_FD_INSIGHTS: "CAN_MANAGE_FD_INSIGHTS"
};

// permission <-> roles map
export const PermissionRoles = {
  [PERMISSIONS.CAN_MANAGE_EVENT]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
    ROLES.ACCOUNT_ADMIN,

    ROLES.EVENT_ADD,
    ROLES.EVENT_EDIT,
  ],
  [PERMISSIONS.CAN_VIEW_API]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
    ROLES.ACCOUNT_ADMIN,

    ROLES.EVENT_ADD,
    ROLES.EVENT_EDIT,
  ],
  [PERMISSIONS.CAN_VIEW_INTERNAL_API]: [ROLES.SYSTEM_DEVELOPER],
  [PERMISSIONS.CAN_MANAGE_BADGE_DESIGN]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
    ROLES.ACCOUNT_ADMIN,

    ROLES.BADGE_DESIGNER_ADD,
    ROLES.BADGE_DESIGNER_EDIT,
  ],
  [PERMISSIONS.CAN_MANAGE_BADGE_SIZE]: [
    ROLES.SYSTEM_DEVELOPER,
    // ROLES.SUPER_USER,
    // ROLES.ACCOUNT_ADMIN,

    // ROLES.BADGE_SIZE_ADD,
    // ROLES.BADGE_SIZE_EDIT
  ],
  [PERMISSIONS.CAN_MANAGE_ACCOUNT]: [ROLES.SYSTEM_DEVELOPER, ROLES.SUPER_USER],
  [PERMISSIONS.CAN_MANAGE_DEV_ACCOUNT]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
  ],
  [PERMISSIONS.CAN_MANAGE_USER]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
    ROLES.ACCOUNT_ADMIN,
  ],
  [PERMISSIONS.CAN_MANAGE_ATTENDEE]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
    ROLES.ACCOUNT_ADMIN,

    ROLES.EVENT_ADD,
    ROLES.EVENT_EDIT,
  ],
  [PERMISSIONS.CAN_MANAGE_SESSION]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
    ROLES.ACCOUNT_ADMIN,

    ROLES.EVENT_ADD,
    ROLES.EVENT_EDIT,
  ],
  [PERMISSIONS.CAN_MANAGE_RESERVATION]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
    ROLES.ACCOUNT_ADMIN,

    ROLES.EVENT_ADD,
    ROLES.EVENT_EDIT,
  ],
  [PERMISSIONS.CAN_DELETE_EVENT]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
    ROLES.ACCOUNT_ADMIN,

    ROLES.EVENT_DELETE,
  ],
  [PERMISSIONS.CAN_VIEW_ANALYTICS]: [
    ROLES.SYSTEM_DEVELOPER,
    ROLES.SUPER_USER,
    ROLES.ACCOUNT_ADMIN,

    ROLES.EVENT_ADD,
    ROLES.EVENT_EDIT,
    ROLES.EVENT_VIEW,
  ],
  
  /* [STARTs] FdLead Migration ROLLBACK: to bring Lead Retrieval back to portal v1,
     uncomment the list below AND comment out the empty one. Empty means LeadGuard shows the
     "use portal v2" screen on every LR route, and the toggle in EventFormNew hides. */
  // [PERMISSIONS.CAN_MANAGE_LEADS]: [
  //   ROLES.SYSTEM_DEVELOPER,
  //   ROLES.SUPER_USER,
  //   ROLES.ACCOUNT_ADMIN,
  // ],
  [PERMISSIONS.CAN_MANAGE_LEADS]: [],
  /* [ENDs] FdLead Migration ROLLBACK */

  [PERMISSIONS.CAN_MANAGE_KIOSK]: [ROLES.SYSTEM_DEVELOPER, ROLES.SUPER_USER],
  [PERMISSIONS.CAN_MANAGE_FD_INSIGHTS]: [ROLES.SYSTEM_DEVELOPER, ROLES.SUPER_USER, ROLES.ACCOUNT_ADMIN]
};
